import React, { useMemo } from 'react';
import { CustomComponentsProps, CustomComponentsWrapperType } from '@website-editor/customComponents';
import { WebsiteEditorPhotoComponentFragment } from '@graphql/generated';
import { useAddPhototNavigations } from './hooks/useAddPhotoNavigation';
import { WebsiteEditorPhotoTelemetryProvider } from './Photo.telemetry';
import { createLazyComponentFromNamedExport } from '@shared/utils/createLazyComponent';
import { PhotoEditListItem } from './wrappers/PhotoEditListItem/PhotoEditListItem';

// Lazy load sub-components
const PhotoAddListItem = createLazyComponentFromNamedExport(
  () => import(/* webpackChunkName: "content/websiteEditorPhotoAddListItem" */ './wrappers/PhotoAddListItem/PhotoAddListItem'),
  'PhotoAddListItem',
);

const PhotoUpload = createLazyComponentFromNamedExport(() => import('./components/PhotoUpload'), 'PhotoUpload');

export interface PhotoProps
  extends CustomComponentsProps,
    Readonly<{
      componentData: WebsiteEditorPhotoComponentFragment;
      isLastItem?: boolean;
    }> {}

export const Photo: React.FC<PhotoProps> = props => {
  const { wrapperType, componentData, ...restProps } = props;
  useAddPhototNavigations(props);

  const getRenderComponent = useMemo(() => {
    switch (wrapperType) {
      case CustomComponentsWrapperType.AddComponentList:
        return (
          <PhotoAddListItem
            {...restProps}
            componentData={componentData}
          />
        );
      case CustomComponentsWrapperType.EditComponentList:
        return (
          <PhotoEditListItem
            {...restProps}
            componentData={componentData}
          />
        );
      default:
        return (
          <PhotoUpload
            {...restProps}
            isEditMode
            isSingleComponent
          />
        );
    }
  }, [componentData, restProps, wrapperType]);

  return <WebsiteEditorPhotoTelemetryProvider>{getRenderComponent}</WebsiteEditorPhotoTelemetryProvider>;
};
